import React from 'react';
import { calculateDamage_0, calculateDamagePercentage } from './utils';

const CalculationsSection = ({
  displayData,
  calculateDamage_0_func,
  calculateDamagePercentage_func,
  calculateTotalDamage_0,
  calculateTotalDamage_1_25,
  calculateTotalDamage_25_1_50,
  calculateTotalDamage_50_1_75,
  calculateTotalDamage_75_1_100,
  calculateTotalDamagePercentage,
  calculationsScrollRef,
  calculationsScrollPosition,
  handleCalculationsSliderChange,
  handleCalculationsScroll
}) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <h3 style={{ 
        margin: '0 0 15px 0', 
        fontSize: '16px', 
        fontWeight: '600',
        color: '#333'
      }}>
        Расчеты
      </h3>
      
      <div 
        ref={calculationsScrollRef}
        onScroll={handleCalculationsScroll}
        style={{
          overflowX: 'auto',
          border: '1px solid #dee2e6',
          borderRadius: '6px',
          backgroundColor: '#fff'
        }}>
        <table style={{
          width: '100%',
          minWidth: '800px',
          borderCollapse: 'collapse',
          fontSize: '12px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ 
                minWidth: '150px', 
                width: '150px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                Наименование
              </th>
              <th style={{ 
                minWidth: '80px', 
                width: '80px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                0%
              </th>
              <th style={{ 
                minWidth: '100px', 
                width: '100px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                1-25%
              </th>
              <th style={{ 
                minWidth: '100px', 
                width: '100px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                26-50%
              </th>
              <th style={{ 
                minWidth: '100px', 
                width: '100px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                51-75%
              </th>
              <th style={{ 
                minWidth: '100px', 
                width: '100px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                76-100%
              </th>
              <th style={{ 
                minWidth: '150px', 
                width: '150px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                Повреждение крон
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Итог по 1-му ярусу - всегда показываем */}
            <tr>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'left',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                Итог по 1-му ярусу
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                {(() => {
                  const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
                  const firstYarusData = dataArray.filter(item => item.yarus === '1' || item.yarus === 1);
                  if (firstYarusData.length > 0) {
                    const total = firstYarusData.reduce((sum, item) => {
                      const damage_0_value = calculateDamage_0_func(item);
                      const dolap = Number(item.dolap) || 0;
                      return sum + (damage_0_value * dolap / 10);
                    }, 0);
                    return total.toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                {(() => {
                  const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
                  const firstYarusData = dataArray.filter(item => item.yarus === '1' || item.yarus === 1);
                  if (firstYarusData.length > 0) {
                    const total = firstYarusData.reduce((sum, item) => {
                      const value = Number(item.objedola25) || 0;
                      const dolap = Number(item.dolap) || 0;
                      return sum + (value * dolap / 10);
                    }, 0);
                    return total.toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                {(() => {
                  const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
                  const firstYarusData = dataArray.filter(item => item.yarus === '1' || item.yarus === 1);
                  if (firstYarusData.length > 0) {
                    const total = firstYarusData.reduce((sum, item) => {
                      const value = Number(item.objedola50) || 0;
                      const dolap = Number(item.dolap) || 0;
                      return sum + (value * dolap / 10);
                    }, 0);
                    return total.toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                {(() => {
                  const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
                  const firstYarusData = dataArray.filter(item => item.yarus === '1' || item.yarus === 1);
                  if (firstYarusData.length > 0) {
                    const total = firstYarusData.reduce((sum, item) => {
                      const value = Number(item.objedola75) || 0;
                      const dolap = Number(item.dolap) || 0;
                      return sum + (value * dolap / 10);
                    }, 0);
                    return total.toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                {(() => {
                  const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
                  const firstYarusData = dataArray.filter(item => item.yarus === '1' || item.yarus === 1);
                  if (firstYarusData.length > 0) {
                    const total = firstYarusData.reduce((sum, item) => {
                      const value = Number(item.objedola100) || 0;
                      const dolap = Number(item.dolap) || 0;
                      return sum + (value * dolap / 10);
                    }, 0);
                    return total.toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500',
                fontSize: '13px'
              }}>
                {(() => {
                  const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
                  const firstYarusData = dataArray.filter(item => item.yarus === '1' || item.yarus === 1);
                  if (firstYarusData.length > 0) {
                    const total = firstYarusData.reduce((sum, item) => {
                      const damagePercentage = calculateDamagePercentage_func(item);
                      const dolap = Number(item.dolap) || 0;
                      return sum + (damagePercentage * dolap / 10);
                    }, 0);
                    return total.toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
            </tr>

            {/* Итог по 2-му ярусу - показываем если есть данные */}
            {(() => {
              const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
              const secondYarusData = dataArray.filter(item => item.yarus === '2' || item.yarus === 2);
              if (secondYarusData.length > 0) {
                return (
                  <tr>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'left',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      Итог по 2-му ярусу
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {secondYarusData.reduce((sum, item) => {
                        const damage_0_value = calculateDamage_0_func(item);
                        const dolap = Number(item.dolap) || 0;
                        return sum + (damage_0_value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {secondYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola25) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {secondYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola50) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {secondYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola75) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {secondYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola100) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {secondYarusData.reduce((sum, item) => {
                        const damagePercentage = calculateDamagePercentage_func(item);
                        const dolap = Number(item.dolap) || 0;
                        return sum + (damagePercentage * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                  </tr>
                );
              }
              return null;
            })()}

            {/* Итог по 3-му ярусу - показываем если есть данные */}
            {(() => {
              const dataArray = Array.isArray(displayData?.data) ? displayData.data : [];
              const thirdYarusData = dataArray.filter(item => item.yarus === '3' || item.yarus === 3);
              if (thirdYarusData.length > 0) {
                return (
                  <tr>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'left',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      Итог по 3-му ярусу
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {thirdYarusData.reduce((sum, item) => {
                        const damage_0_value = calculateDamage_0_func(item);
                        const dolap = Number(item.dolap) || 0;
                        return sum + (damage_0_value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {thirdYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola25) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {thirdYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola50) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {thirdYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola75) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {thirdYarusData.reduce((sum, item) => {
                        const value = Number(item.objedola100) || 0;
                        const dolap = Number(item.dolap) || 0;
                        return sum + (value * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '8px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px'
                    }}>
                      {thirdYarusData.reduce((sum, item) => {
                        const damagePercentage = calculateDamagePercentage_func(item);
                        const dolap = Number(item.dolap) || 0;
                        return sum + (damagePercentage * dolap / 10);
                      }, 0).toFixed(2)}
                    </td>
                  </tr>
                );
              }
              return null;
            })()}

            {/* Итог по насаждению - всегда показываем */}
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'left',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                Итог по насаждению
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                {calculateTotalDamage_0()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                {calculateTotalDamage_1_25()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                {calculateTotalDamage_25_1_50()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                {calculateTotalDamage_50_1_75()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                {calculateTotalDamage_75_1_100()}
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px'
              }}>
                {calculateTotalDamagePercentage()}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      {/* Слайдбар для прокрутки таблицы расчетов */}
      <div style={{
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '60px'
        }}>
          Прокрутка:
        </span>
        <input
          type="range"
          min="0"
          max="100"
          value={calculationsScrollPosition}
          onChange={handleCalculationsSliderChange}
          className="table-scroll-slider"
          style={{
            flex: 1
          }}
        />
        <span style={{
          fontSize: '12px',
          color: '#6c757d',
          minWidth: '30px',
          textAlign: 'right'
        }}>
          {Math.round(calculationsScrollPosition)}%
        </span>
      </div>
    </div>
  );
};

export default CalculationsSection;

